<div class="row component-card mt-0 mt-md-5">
  <div class="col-12 col-md-6 order-2 order-md-1">
    <div class="row mx-lg-2">
      <div *ngFor="let member of data.team" class="col-6 member">
        <img
          class="person-img"
          [src]="member.imagesrc"
          [alt]="member.name + member.position"
        />
        <h4 class="name">{{ member.name }}</h4>
        <h6 class="position">{{ member.position }}</h6>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 left-card order-1 order-md-2">
    <h1>
      <span class="strok-text">{{ data.title.split(" ")[0] }}</span
      >{{ data.title.split(" ")[1] }}
    </h1>

    <h5 class="mb-4" [innerHTML]="data.description"></h5>
  </div>
</div>
